/* eslint-disable react/no-did-mount-set-state */
import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from 'components/ErrorBoundary';
import PlaneLayoutWithAuthor from './PlaneLayoutWithAuthor';
import RenderInserts from '../../desktop/RenderInserts/RenderInserts';

function PlaneLayoutWithAuthorV2(props) {
  const { sectionItem } = props;
  return (
    <ErrorBoundary>
      <PlaneLayoutWithAuthor
        sectionData={sectionItem}
        key={sectionItem.id}
        overrideClass={props.overrideClass}
        isWapView={props.isWapView}
      >
        <RenderInserts
          key={`${sectionItem.id}_inserts`}
          data={sectionItem.inserts}
          timesTop10={props.timesTop10}
          isWapView={props.isWapView}
          addMarginTop={sectionItem.id === 'bestsellers'}
          newga={`${sectionItem.name}Section_Actions#`}
          toggleLoginBox={props.toggleLoginBox}
          isLoggedIn={props.isLoggedIn}
        />
      </PlaneLayoutWithAuthor>
    </ErrorBoundary>
  );
}
PlaneLayoutWithAuthorV2.propTypes = {
  sectionItem: PropTypes.shape({}).isRequired,
  isWapView: PropTypes.bool,
  timesTop10: PropTypes.shape({}),
  overrideClass: PropTypes.string,
};

PlaneLayoutWithAuthorV2.defaultProps = {
  isWapView: false,
  timesTop10: undefined,
  overrideClass: '',
};

export default PlaneLayoutWithAuthorV2;
